import React from "react";

import { cn } from "../../../Utils/helper";

const Requirement = ({
  title,
  body,
  className,
  isIneligible = false,
  isEnable,
}) => {
  if (!body || (Array.isArray(body) && body.length === 0)) {
    return null;
  }

  const bodyArray = Array.isArray(body) ? body : [body];

  const borderColor =
    isIneligible || isEnable === false ? "border-red-500" : "border-blue-300";
  const textColor =
    isIneligible || isEnable === false ? "text-red-500" : "text-[#253FF6]";

  return (
    <div
      className={`relative mt-7 border ${borderColor} rounded-xl  bg-white ${className}`}
    >
      {title && (
        <div className="absolute -top-3 left-4 bg-white px-2 py-0.5 rounded">
          <span className={`${textColor} font-bold text-base`}>{title}</span>
        </div>
      )}

      <div className="p-3">
        {bodyArray.map((item, index) => {
          // Tách theo \n
          const lines = item.split("\\n"); // hoặc "\n" nếu bạn truyền thẳng từ JS
          return (
            <div key={index}>
              {lines.map((line, i) => (
                <div
                  key={i}
                  className="text-[#253FF6] text-base font-medium leading-relaxed flex items-start"
                >
                  <span
                    className={cn(
                      "mr-2 mt-1",
                      isEnable === false ? "text-red-500" : "text-[#253FF6]"
                    )}
                  >
                    •
                  </span>
                  <span className={`${textColor} leading-relaxed flex-1`}>
                    {isEnable === false
                      ? "You gotta finish the Introductory Quest first!"
                      : line}
                  </span>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default Requirement;
